module.exports = "/assets/1874d0ba67f03cd10a5be46cc72b54b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UO.png
// module id = 1898
// module chunks = 0